import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=76a4a913&scoped=true&functional=true&"
var script = {}
import style0 from "./dialog.vue?vue&type=style&index=0&id=76a4a913&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "76a4a913",
  null
  
)

export default component.exports